import { Box, Typography } from '@mui/material'
import AdxStatusBar from 'components/reusable/statusBar/AdxStatusBar'
import React from 'react'
import PayrollCategoryModal from './PayrollCategoryModal'
import RemoveCustomCategory from './RemoveCustomCategoryModal'

export const CustomCategoryList = ({ isLoading, props, details, sx }) => {
  const { title, epf, socso, eis, lhdn, hrdf } = details
  let array = []

  ;[epf, socso, eis, lhdn, hrdf].map((list) => {
    if (list.status === 1) {
      array.push(list.name)
    }
    return null
  })

  let subjectedStatutory = array.join(', ')
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      padding={2}
      sx={{ ...sx }}
    >
      <Box display="flex" alignItems="center" sx={{ width: 'calc(100% * 2 / 5)', mr: 2 }}>
        <Typography noWrap variant="subtitle1" mr={2}>
          {title}
        </Typography>
        {details.default === 0 && (
          <AdxStatusBar
            status={{
              text: 'Default',
              bgColor: 'gray-background.main',
              color: 'light-gray-text.main',
            }}
          />
        )}
      </Box>
      <Box sx={{ width: 'calc(100% * 2 / 5)' }} display="flex">
        <Typography
          noWrap
          color="light-gray-text.main"
          sx={{ mr: 1 }}
        >{`Statutory eligibility:`}</Typography>
        <Typography variant="subtitle1" color="alternate.main" sx={{ mr: 1 }}>
          {subjectedStatutory}
        </Typography>
      </Box>
      <Box
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
        sx={{ width: 'calc(100% * 1 / 5)' }}
      >
        {details.default === 1 && (
          <>
            <RemoveCustomCategory props={details}>
              <Typography
                sx={{ cursor: 'pointer', textDecoration: 'underline' }}
                variant="subtitle1"
                color="error.main"
              >
                Delete
              </Typography>
            </RemoveCustomCategory>
            <PayrollCategoryModal props={props} details={details}>
              <Typography
                sx={{ cursor: 'pointer', textDecoration: 'underline' }}
                ml={2}
                variant="subtitle1"
                color="alternate.main"
              >
                Edit
              </Typography>
            </PayrollCategoryModal>
          </>
        )}
      </Box>
    </Box>
  )
}
